module.exports = __webpack_public_path__ + "media/images/lb/551-7fb5a6116e0527ce59056ab2373fcf14.svg";